import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'md-wrapper',
  templateUrl: './wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrapperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
